import { useTranslation } from "react-i18next";

import styles from "./styles.module.css";

export default function HelpScreenText() {
  const { t } = useTranslation();
  const consent = window.applicationManager.AnalyticsFacade.consent;

  let optingOutAnalyticsOptions = t("help.analytics_opt_out");
  return (
    <>
      <h2 className={styles.helpScreenTextTitle}>{t("help.title")}</h2>

      <p className={styles.helpScreenTextParagraph}>
        <span className={styles.helpScreenTextBoldSpan}>
          {t("help.analytics_heading")}
        </span>
      </p>
      <p className={styles.helpScreenTextParagraph} style={{ marginBottom: "2rem" }}>
        {t("help.analytics_status_prefix")}
        {!consent ? (
          <span className={styles.helpScreenTextBoldSpan}>
            {t("help.analytics_not")}
          </span>
        ) : (
          ""
        )}
        {t("help.analytics_status_suffix")}
        {consent ? (
          <span className={styles.helpScreenTextParagraph}>
            {t("help.analytics_connected")} {optingOutAnalyticsOptions}
          </span>
        ) : null}
      </p>

      <p className={styles.helpScreenTextParagraph}>
        <span className={styles.helpScreenTextBoldSpan}>
          {t("help.troubleshooting_heading")}
        </span>
      </p>
      <p className={styles.helpScreenTextParagraph}>
        {t("help.troubleshooting_bluetooth")}
      </p>
      <p className={styles.helpScreenTextParagraph}>
        {t("help.troubleshooting_robot")}
      </p>
      <p className={styles.helpScreenBottomParagraph}>
        {t("help.further_support")}
      </p>
    </>
  );
}
